// extracted by mini-css-extract-plugin
export var boldText = "_6d-4";
export var checkboxContainer = "_6d-6";
export var closeIcon = "_6d-i";
export var container = "_6d-0";
export var drawer = "_6d-8";
export var drawerContent = "_6d-9";
export var extraSmallText = "_6d-5";
export var fulfillmentGroupTable = "_6d-e";
export var largeText = "_6d-3";
export var loadingSpinnerContainer = "_6d-j";
export var mediumText = "_6d-2";
export var narrow = "_6d-f";
export var notificationLink = "_6d-l";
export var packageCheckIconContainer = "_6d-7";
export var slideoutHeaderActions = "_6d-g";
export var slideoutHeaderActionsShifted = "_6d-h";
export var slideoutHeaderContainer = "_6d-a";
export var slideoutModal = "_6d-c";
export var stickyHeaderWrapper = "_6d-b";
export var table = "_6d-k";
export var tableContainer = "_6d-d";
export var tertiaryText = "_6d-1";